import { Box } from '@mui/material';
import { useNavState } from '../navState/NavStateContext';
import { usePrincipal } from '../principal/PrincipalContext';
import { SideNavButton } from './SideNavButton';

export const OrgIcon = () => {
  const { org } = usePrincipal();
  const { navigateTo } = useNavState();

  return (
    <SideNavButton
      onClick={() => navigateTo('/')}
      icon={<Box component="img" src={`/assets/icons/${org.toLowerCase()}.png`} sx={{ width: '24px', height: '24px' }} />}
      label="Home"
    />
  )
}